import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { label: String }

  connect() {
    this.applyLabel()
    this.observer = new MutationObserver(() => this.applyLabel())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  applyLabel() {
    const canvas = this.element.querySelector("canvas")
    if (!canvas) return

    canvas.setAttribute("role", "img")
    canvas.setAttribute("aria-label", this.labelValue)
    this.observer?.disconnect()
  }
}
